var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu3X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666626 2.83333C0.666626 2.3731 1.00863 2 1.43051 2H14.5694C14.9913 2 15.3333 2.3731 15.3333 2.83333C15.3333 3.29357 14.9913 3.66667 14.5694 3.66667H1.43051C1.00863 3.66667 0.666626 3.29357 0.666626 2.83333ZM0.666626 7.5C0.666626 7.03976 1.00863 6.66667 1.43051 6.66667H14.5694C14.9913 6.66667 15.3333 7.03976 15.3333 7.5C15.3333 7.96024 14.9913 8.33333 14.5694 8.33333H1.43051C1.00863 8.33333 0.666626 7.96024 0.666626 7.5ZM1.43051 11.3333C1.00863 11.3333 0.666626 11.7064 0.666626 12.1667C0.666626 12.6269 1.00863 13 1.43051 13H14.5694C14.9913 13 15.3333 12.6269 15.3333 12.1667C15.3333 11.7064 14.9913 11.3333 14.5694 11.3333H1.43051Z",
    fill: "#132322"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu3X);
export default __webpack_public_path__ + "static/media/menu3x.52cc17a327296e6394f33e8c20abc62c.svg";
export { ForwardRef as ReactComponent };